module.exports = __webpack_public_path__ + "img/search.94674eef.svg";